export default "__VITE_ASSET__DHr4MlFd__"